import React, { useEffect, useState } from "react";
import { Form, DatePicker, Radio, Checkbox } from "antd";
const { RangePicker } = DatePicker;
import Analysisapi from "@/api/analysis";
import Modal from "../Modal";

export default ({ visible, close, reportType, exportFileName }) => {
  const [form] = Form.useForm();
  const [excelHeadList, setExcelHeadList] = useState([]);
  const [station, setStation] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStation();
  }, []);

  const getStation = () => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        setStation(res.data);
      }
    });
  };

  const cancel = () => {
    form.resetFields();
    setExcelHeadList([]);
    close && close();
  };

  const getTableHead = () => {
    const values = form.getFieldsValue();
    if (values.date && values.date.length == 2 && values.stationId) {
      const params = {
        reportType, //(1 - 水质  2-能耗)
        stationId: values.stationId,
        queryTimeStartStr: values.date[0].format("YYYY-MM-DD") + " 00:00:00",
        queryTimeEndStr: values.date[1].format("YYYY-MM-DD") + " 23:59:59",
      };
      Analysisapi.selectQualityHeadList(params).then((res) => {
        if (res.status != "0") return;
        setExcelHeadList(res.data);
      });
    }
  };

  const exportData = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      Analysisapi.exportQualityData({
        queryTimeStartStr: values.date[0].format("YYYY-MM-DD") + " 00:00:00",
        queryTimeEndStr: values.date[1].format("YYYY-MM-DD") + " 23:59:59",
        stationId: values.stationId,
        stationIds: [values.stationId],
        reportType,
        excelHeadList: values.excelHeadList,
      })
        .then((res) => {
          setLoading(false);
          let a = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", `${exportFileName}.xls`);
          a.click();
          cancel();
        })
        .catch(() => {
          setLoading(false);
        });
    });
  };

  return (
    <Modal
      title="导出数据"
      visible={visible}
      onCancel={() => cancel()}
      onSubmit={() => exportData()}
      loading={loading}
    >
      <div>
        <Form form={form}>
          <Form.Item
            name="date"
            label="日期"
            rules={[{ required: true, message: "请选择日期" }]}
          >
            <RangePicker onChange={getTableHead} />
          </Form.Item>
          <Form.Item
            name="stationId"
            label="厂站"
            rules={[{ required: true, message: "请选择场站" }]}
          >
            <Radio.Group onChange={getTableHead}>
              {station.map((item, index) => {
                return (
                  <Radio key={index} value={item.id}>
                    {item.aliasName || item.name}
                  </Radio>
                );
              })}
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="excelHeadList"
            label="表头"
            rules={[{ required: true, message: "请选择表头" }]}
          >
            <Checkbox.Group
              options={excelHeadList.map((item) => {
                return {
                  label: item,
                  value: item,
                };
              })}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};
